var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Configuration } from "./Configuration";
/**
 * Checks value is Array
 */
export function isArray(value) {
    return Array.isArray(value);
}
/**
 * Checks value is Object
 */
export function isObject(value) {
    return value != null && typeof value === 'object' && !Array.isArray(value);
}
/**
 * Checks value is primitive
 */
export function isPrimitive(value) {
    return value !== Object(value);
}
/**
 * Checks object is proxy
 * @param object
 */
export function isProxy(object) {
    if (object == null) {
        return false;
    }
    return globalThis.Object.getOwnPropertyDescriptor(object, '_proxy_target_') != null;
}
/**
 * Sets proxy target
 * @param proxy
 * @param target
 */
export function setProxyTarget(proxy, target) {
    globalThis.Object.defineProperty(proxy, '_proxy_target_', {
        value: target,
        writable: true
    });
}
/**
 * Gets proxy target
 * @param proxy
 */
export function getProxyTarget(proxy) {
    return globalThis.Object.getOwnPropertyDescriptor(proxy, '_proxy_target_').value;
}
/**
 * Sets proxy handler
 * @param proxy proxy
 * @param proxyHandler proxy handler
 */
export function setProxyHandler(proxy, proxyHandler) {
    globalThis.Object.defineProperty(proxy, '_proxy_handler_', {
        value: proxyHandler,
        writable: true
    });
}
/**
 * Gets proxy handler
 * @param proxy proxy
 */
export function getProxyHandler(proxy) {
    return globalThis.Object.getOwnPropertyDescriptor(proxy, '_proxy_handler_').value;
}
/**
 * Gets element query selector
 */
export function getElementQuerySelector() {
    let namespace = Configuration.getNamespace();
    return `*[data-${namespace}-bind]:not([data-${namespace}-id])`;
}
/**
 * Marks element as initialized
 * @param container container
 */
export function markInitialized(container) {
    container.querySelectorAll(getElementQuerySelector()).forEach(element => {
        setElementAttribute(element, 'id', '_');
    });
}
/**
 * Finds variable in current scope
 * @param context current context
 * @param name variable name
 */
export function findVariable(context, name) {
    // find in context
    try {
        let object = new Function(`return this.${name};`).call(context);
        if (object) {
            return object;
        }
    }
    catch (ignore) { }
    // find in global
    try {
        let object = new Function(`return ${name};`).call(null);
        if (object) {
            return object;
        }
    }
    catch (ignore) { }
    // return default
    return undefined;
}
/**
 * Calls function
 * @param fn function
 * @param context context
 * @param args arguments
 */
export function callFunction(fn, context, ...args) {
    try {
        const result = fn.call(context, ...args);
        return (result && typeof result.then === 'function')
            ? result
            : Promise.resolve(result);
    }
    catch (e) {
        return Promise.reject(e);
    }
}
/**
 * Runs code
 * @param code
 * @param htmlElement
 * @param context
 */
export function runCode(code, htmlElement, context) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            let args = [];
            let values = [];
            for (let property in context) {
                args.push(property);
                values.push(context[property]);
            }
            return yield Function(...args, code).call(htmlElement, ...values);
        }
        catch (e) {
            console.error(code, e);
            throw e;
        }
    });
}
/**
 * Runs if code
 * @param htmlElement html element
 * @param context current context
 */
export function runIfCode(htmlElement, context) {
    return __awaiter(this, void 0, void 0, function* () {
        let ifClause = getElementAttribute(htmlElement, 'if');
        if (ifClause) {
            let result = yield runCode(ifClause, htmlElement, context);
            if (!result) {
                htmlElement.hidden = true;
            }
            else {
                htmlElement.hidden = false;
            }
            return result;
        }
        return true;
    });
}
/**
 * Runs execute code
 * @param htmlElement html element
 * @param context current context
 */
export function runExecuteCode(htmlElement, context) {
    return __awaiter(this, void 0, void 0, function* () {
        let script = getElementAttribute(htmlElement, 'execute');
        if (script) {
            return yield runCode(script, htmlElement, context);
        }
        return null;
    });
}
/**
 * Checks if element has attribute
 * @param htmlElement html element
 * @param name attribute name
 */
export function hasElementAttribute(htmlElement, name) {
    let namespace = Configuration.getNamespace();
    return htmlElement.hasAttribute(`data-${namespace}-${name}`);
}
/**
 * Gets element attribute
 * @param htmlElement html element
 * @param name attribute name
 */
export function getElementAttribute(htmlElement, name) {
    let namespace = Configuration.getNamespace();
    return htmlElement.getAttribute(`data-${namespace}-${name}`);
}
/**
 * Sets element attribute
 * @param htmlElement html element
 * @param name attribute name
 * @param value attribute value
 */
export function setElementAttribute(htmlElement, name, value) {
    let namespace = Configuration.getNamespace();
    htmlElement.setAttribute(`data-${namespace}-${name}`, value);
}
/**
 * Prints debug message
 */
export function debug(...args) {
    if (Configuration.isDebugEnabled()) {
        console.trace(args);
    }
}
/**
 * Asserts condition
 * @param condition condition
 * @param message assertion message
 */
export function assert(condition, message) {
    console.assert(condition, message);
    if (!condition) {
        throw new Error(message || 'Assertion Failed');
    }
}
//# sourceMappingURL=common.js.map